<template lang="pug">
shListData(title="Productos" resolver="products" keyData="product" component="shProduct")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Products',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/Products.vue